import { Component, Input, OnInit, ViewChild, Output, EventEmitter, HostListener, OnDestroy,ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import SignaturePad from 'signature_pad';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { InteractorService } from 'src/app/core/services/interactor.service';

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss']
})
export class SignaturePadComponent implements OnInit, OnDestroy {
  @Input() category: string;
  @Input() versionItem: any;
  @Input() index: number;
  @Input() group: number;
  @Input() groupItem: number;
  @Input() child: number;
  @Input() childData: any;
  @Input() type: string;
  @Input() signatureType: string;
  @Input() doodleType: string;
  @Input() imageArray: any[];
  @Input() assesmentNumber: number;
  @Input() formViewFlag: boolean;
  @Input() isChildItem: boolean;
  @Input() qStatus: string;
  @Input() signatureSubmitted: boolean = false;
  @Input() isDisableResponse: boolean = false;

  signaturePad: any;
  isImageSet = false;
  width = 400;
  height = 200;
  showAdditionalActions = false
  doodleImage = null;
  duplicateImage = null;
  submit = false;

  @ViewChild('signaturepadWrapper', { static: true }) signaturepadWrapper;
  @ViewChild('signaturePadDuplicate', { static: true }) signaturePadDuplicate;
  @Output() CustomCallBack: EventEmitter<any> = new EventEmitter();
  @Output() CustomCallBackOnEdit: EventEmitter<any> = new EventEmitter();
  @Output() signatureSaved: EventEmitter<boolean> = new EventEmitter();
  brandingSubscription$: Subscription;
  showIcons = true;
  brandingDetails = JSON.parse(localStorage.getItem('branding'));
  redColor = this.brandingDetails?.branding?.BackgroundColors?.RequiredAsterisk;
  whiteColor = this.brandingDetails?.branding?.BackgroundColors?.RowHoverNotification;
  currentCard = this.brandingDetails?.branding?.BackgroundColors?.CurrentCardBackground;
  isSkipped: any;
  constructor(private translatorService: TranslateService, private interactorService: InteractorService, private toastr: ToastrService,private cdr: ChangeDetectorRef) { }  /**
   * Handles window resize events to adjust canvas width and redraw signature/doodle images
   * Maintains proper aspect ratio and responsiveness across different screen sizes
   * @param event - The resize event containing window dimensions
   */
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    try {
      const canvas = document.getElementById(this.category + '-' + this.index + '-' + this.group + '-' + this.groupItem + '-' + this.child) as HTMLCanvasElement;
      if (!canvas) {
        console.error('Canvas element not found');
        return;
      }

      const width = event.target.innerWidth;

      if (this.assesmentNumber == null) {
        if (width <= 650) {
          canvas.width = this.signaturepadWrapper?.nativeElement?.offsetWidth - 25 || 375;
        } else {
          canvas.width = 400;
        }
      } else {
        canvas.width = 400;
      }

      if (this.type === this.doodleType) {
        if (this.duplicateImage !== null && this.duplicateImage != undefined && this.duplicateImage != "") {
          this.setImage(canvas.width, 400, this.duplicateImage);
          this.showAdditionalActions = true;
        }
        else {
          this.setImage(canvas.width, 400, this.doodleImage);
        }
      } else {
        if (this.duplicateImage !== null && this.duplicateImage != undefined && this.duplicateImage != "") {
          this.setImage(canvas.width, 200, this.duplicateImage);
          this.showAdditionalActions = true;
        }
      }
    } catch (error) {
      console.error('Error in resize event handler:', error);
    }
  }

  /**
   * Lifecycle hook that initializes the signature pad after view initialization
   * Sets up canvas element and loads any existing signature/doodle data
   */
  ngAfterViewInit(): void {
    try {
      let canvas = this.signaturePadDuplicate?.nativeElement;
      this.height = this.type == this.doodleType ? 400 : 200;
      if (!canvas) {
        console.error('Canvas element not found');
        return;
      }

      if (!this.isChildItem) {
        this.setupNonChildItem(canvas);
      } else {
        this.setupChildItem(canvas);
      }
    } catch (error) {
      console.error('Error in ngAfterViewInit:', error);
      this.toastMessage('Error initializing signature pad');
    }
  }

  /**
   * Sets up signature pad for non-child items (regular signature/doodle components)
   * Searches for existing images in imageArray or assessment data and initializes the pad
   * @param canvas - The HTML canvas element for the signature pad
   */
  setupNonChildItem(canvas: HTMLCanvasElement): void {
    try {
      // Find duplicate image from image array
      if (this.imageArray && Array.isArray(this.imageArray)) {
        const matchingImage = this.imageArray.find(element =>
          element.index === this.index && element.category === this.category);
        if (matchingImage) {
          this.duplicateImage = matchingImage.original;
        }
      }

      // Check for assessment data if duplicate image not found
      if ((!this.duplicateImage || this.duplicateImage === '') && this.assesmentNumber) {
        const assessmentArray = this.versionItem?.controls?.assesments?.value;
        if (assessmentArray && Array.isArray(assessmentArray)) {
          assessmentArray.forEach(element => {
            if ((element.files && element.files.length > 0 && element.files[0]?.FileBase64) &&
              element.assessmentID === this.assesmentNumber) {
              this.duplicateImage = 'data:image/png;base64,' + element.files[0]?.FileBase64;
            }
          });
        }
      }

      this.initializeSignaturePad(canvas);
      this.checkAssessmentStatus();
    } catch (error) {
      console.error('Error in setupNonChildItem:', error);
    }
  }

  /**
   * Sets up signature pad for child items (nested signature/doodle components within groups)
   * Handles more complex identification using group, groupItem, and child indices
   * @param canvas - The HTML canvas element for the signature pad
   */
  setupChildItem(canvas: HTMLCanvasElement): void {
    try {
      // Find duplicate image from image array for child item
      if (this.imageArray && Array.isArray(this.imageArray)) {
        const matchingImage = this.imageArray.find(element =>
          element.index === this.index && element.category === this.category &&
          this.group === element.group && this.groupItem === element.groupItem &&
          this.child === element.child);
        if (matchingImage) {
          this.duplicateImage = matchingImage.original;
        }
      }

      // Check for assessment data if duplicate image not found
      if ((!this.duplicateImage || this.duplicateImage === '') && this.assesmentNumber != undefined) {
        const childItem = this.versionItem?.controls?.childItems?.controls[this.group]
          ?.controls[this.groupItem]?.controls[this.child]?.value;

        if (childItem?.childValue && childItem?.childValue.includes('https')) {
          this.duplicateImage = childItem?.childValue;
        } else {
          this.duplicateImage = childItem?.childValue ? 'data:image/png;base64,' + childItem?.childValue : '';
        }

        this.loadChildItemFromAssessment();
      }

      this.initializeSignaturePad(canvas);
      this.checkAssessmentStatus();
    } catch (error) {
      console.error('Error in setupChildItem:', error);
    }
  }

  /**
   * Loads signature/doodle data from assessment for child items
   * Parses childItemResponses JSON and finds matching child item data
   */
  loadChildItemFromAssessment(): void {
    try {
      const assessmentArray = this.versionItem?.controls?.assesments?.value;
      if (!assessmentArray || !Array.isArray(assessmentArray)) return;

      assessmentArray.forEach(element => {
        if (element.assessmentID === this.assesmentNumber && element.childItemResponses) {
          try {
            const childItemResponses = JSON.parse(element.childItemResponses);
            const childItem = childItemResponses?.find(val =>
              val.ChildItemID == this.childData?.ChildItemID && val?.GroupNumber == this.childData?.groupNo);

            if (childItem?.Attachments && childItem?.Attachments[0]?.FileBase64) {
              this.duplicateImage = 'data:image/png;base64,' + childItem?.Attachments[0]?.FileBase64;
            } else if (!this.duplicateImage && childItem?.Value) {
              this.duplicateImage = 'data:image/png;base64,' + childItem?.Value;
            }
          } catch (parseError) {
            console.error('Error parsing child item responses:', parseError);
          }
        }
      });
    } catch (error) {
      console.error('Error loading child item from assessment:', error);
    }
  }

  /**
   * Initializes the SignaturePad library with the canvas element
   * Sets up canvas dimensions, background/pen colors, and loads existing images
   * @param canvas - The HTML canvas element to initialize the signature pad on
   */
  initializeSignaturePad(canvas: HTMLCanvasElement): void {
    try {
      const padOptions = {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        penColor: 'rgb(0, 0, 0)'
      };

      this.signaturePad = new SignaturePad(canvas, padOptions);

      // Set canvas width based on window size and type
      if (this.assesmentNumber == null) {
        canvas.width = window.innerWidth <= 650 ?
          (this.signaturepadWrapper?.nativeElement?.offsetWidth - 25 || 375) : 400;
      } else {
        canvas.width = 400;
      }

      // Set up height and image based on type
      if (this.type !== this.doodleType) {
        this.setupSignatureType(canvas);
      } else {
        this.setupDoodleType(canvas);
      }

      // Add event listener for stroke updates
      this.addStrokeUpdateListener();
    } catch (error) {
      console.error('Error initializing signature pad:', error);
    }
  }

  /**
   * Configures the signature pad specifically for signature type (not doodle)
   * Loads existing signature image if available and sets up UI state
   * @param canvas - The HTML canvas element
   */
  setupSignatureType(canvas: HTMLCanvasElement): void {
    if (this.duplicateImage) {
      this.setImage(canvas.width, 200, this.duplicateImage);
      this.showAdditionalActions = true;
      this.notifyEditCallback(true);
      this.submit = true;
    }
  }

  /**
   * Configures the signature pad specifically for doodle type
   * Sets higher canvas height, loads base doodle image, and handles child item doodles
   * @param canvas - The HTML canvas element
   */
  setupDoodleType(canvas: HTMLCanvasElement): void {
    if (this.signaturepadWrapper) {
      this.signaturepadWrapper.height = 400;
    }

    // Look for doodle image in responses
    if (this.versionItem?.controls?.Responses?.value) {
      const responseArray = this.versionItem.controls.Responses.value;
      const doodleResponse = responseArray.find(element => element.Value !== '-');
      if (doodleResponse) {
        this.doodleImage = doodleResponse.Description;
      }
    }

    // Look for doodle image in child items if applicable
    if (this.isChildItem) {
      this.loadDoodleImageFromChildItem();
    }

    if (this.duplicateImage) {
      this.setImage(canvas.width, 400, this.duplicateImage);
      this.showAdditionalActions = true;
      this.notifyEditCallback(true);
      this.submit = true;
    } else {
      this.setImage(canvas.width, 400, this.doodleImage);
    }
  }

  /**
   * Loads doodle base image from assessment data for child items
   * Parses childItemResponses and extracts doodle image attachments
   */
  loadDoodleImageFromChildItem(): void {
    try {
      const assessmentArray = this.versionItem?.controls?.assesments?.value;
      if (!assessmentArray || !Array.isArray(assessmentArray)) return;

      assessmentArray.forEach(element => {
        if (element.assessmentID === this.assesmentNumber) {
          try {
            const childItemResponses = element?.childItemResponses ?
              JSON.parse(element.childItemResponses) : [];

            const childItem = childItemResponses?.find(val =>
              val.ChildItemID == this.childData?.ChildItemID &&
              val?.GroupNumber == this.childData?.groupNo);

            if (childItem?.Attachments && childItem?.Attachments[0]?.FileBase64) {
              this.duplicateImage = 'data:image/png;base64,' + childItem?.Attachments[0]?.FileBase64;
            }
          } catch (parseError) {
            console.error('Error parsing child item responses:', parseError);
          }
        }
      });
    } catch (error) {
      console.error('Error loading doodle image from child item:', error);
    }
  }

  /**
   * Adds event listener to signature pad for stroke updates
   * Triggers edit callback when user starts drawing (indicating unsaved changes)
   */
  addStrokeUpdateListener(): void {
    if (!this.signaturePad) return;

    this.signaturePad.addEventListener('afterUpdateStroke', () => {
      try {
        const data = this.signaturePad.toData();
        if (this.submit === false && (!this.signaturePad.isEmpty() || (data && data.length != 0))) {
          this.notifyEditCallback(false);
        }
      } catch (error) {
        console.error('Error in stroke update listener:', error);
      }
    });
  }

  /**
   * Checks the status of the current assessment and updates UI accordingly
   * Handles skipped assessments and submitted questionnaires by disabling interactions
   */
  checkAssessmentStatus(): void {
    try {
      const assessmentArray = this.versionItem?.controls?.assesments?.value;
      if (assessmentArray && Array.isArray(assessmentArray)) {
        const currentAssessment = assessmentArray.find(
          element => element.assessmentID === this.assesmentNumber
        );
        if (currentAssessment) {
          this.isSkipped = currentAssessment.isSkipped;
        }
      }

      if (this.isSkipped) {
        this.clearSignature();
      }

      if (this.qStatus == 'Submitted' || this.isSkipped) {
        this.showAdditionalActions = false;
        this.showIcons = false;
        this.submit = true;
      } else {
        this.showIcons = true;
        if (!this.signatureSubmitted && !this.duplicateImage) {
          this.showAdditionalActions = false;
          this.submit = false;
        }
      }
    } catch (error) {
      console.error('Error checking assessment status:', error);
    }
  }

  /**
   * Notifies parent component about edit actions (add/remove/edit signatures)
   * Creates assessment object with component identification and emits edit callback
   * @param isRemove - Boolean indicating if this is a remove operation
   */
  notifyEditCallback(isRemove: boolean): void {
    let assessObj: any = {};
    if (!this.isChildItem) {
      assessObj = {
        index: this.index,
        category: this.category,
        original: "",
        isChildItem: this.isChildItem
      };
    } else {
      assessObj = {
        index: this.index,
        category: this.category,
        original: "",
        group: this.group,
        groupItem: this.groupItem,
        child: this.child,
        isChildItem: this.isChildItem,
        childData: this.childData
      };
    }

    if (isRemove) {
      assessObj.remove = true;
    }

    this.CustomCallBackOnEdit.emit(assessObj);
  }

  /**
   * Sets an image on the signature pad canvas
   * Loads base64 or URL image data and adjusts canvas dimensions
   * @param width - Canvas width to set
   * @param height - Canvas height to set
   * @param image - Base64 or URL image data to load
   */
  async setImage(width, height, image) {
    try {
      if (!this.signaturePad) {
        console.error('Signature pad not initialized');
        return;
      }
      this.height = height;
      this.cdr.detectChanges();
      if (!image || image === "") {
        image = null;
      }
      // Validate if the image is actually a valid image string
      if (image && !this.isValidImageString(image)) {
        return;
      }

      if (this.signaturepadWrapper?.nativeElement?.offsetHeight) {
        this.signaturePad.height = this.signaturepadWrapper.nativeElement.offsetHeight;
      }

      if (image) {
        await this.signaturePad.fromDataURL(image, { width: width, height: this.height });
        this.isImageSet = true;
      }
    } catch (error) {
      console.error('Error setting image:', error);
    }
  }
  /**
   * Validates if a string is a valid image data URL or base64 image
   * @param imageString - The string to validate
   * @returns boolean indicating if the string is a valid image
   */
  private isValidImageString(imageString: string): boolean {
    if (!imageString || typeof imageString !== 'string') {
      return false;
    }
    // Check for data URL format (data:image/...)
    const dataUrlPattern = /^data:image\/(png|jpg|jpeg|gif|bmp|webp|svg\+xml);base64,/i;
    if (dataUrlPattern.test(imageString)) {
      return true;
    }
    // Check for HTTP/HTTPS URL format
    const urlPattern = /^https?:\/\/.+\.(png|jpg|jpeg|gif|bmp|webp|svg)(\?.*)?$/i;
    if (urlPattern.test(imageString)) {
      return true;
    }
    // Check if it's just base64 data (without data:image prefix)
    // Base64 strings should only contain valid base64 characters
    const base64Pattern = /^[A-Za-z0-9+/]*={0,2}$/;
    if (base64Pattern.test(imageString) && imageString.length > 20 && imageString.length % 4 === 0) {
      return true;
    }
    return false;
  }

  /**
   * Clears the signature pad and resets to initial state
   * For doodles, restores the base doodle image after clearing user drawings
   */
  clearSignature() {
    try {
      this.signaturePad?.clear();
      this.isImageSet = false;

      if (this.type === this.doodleType) {
        const canvas = document.getElementById(this.category + '-' + this.index + '-' + this.group + '-' + this.groupItem + '-' + this.child) as HTMLCanvasElement;
        if (canvas && this.doodleImage) {
          this.setImage(canvas.width, 400, this.doodleImage);
        }
      } else {
        this.height = 200;
        if (this.signaturePad) {
          this.signaturePad.height = 200;
        }
      }

      this.duplicateImage = null;
      this.updateAssessmentDataOnDelete();
      this.emitCustomCallback();
      this.showAdditionalActions = false;
      this.submit = false;
    } catch (error) {
      console.error('Error clearing signature:', error);
      this.toastMessage('Error clearing signature');
    }
  }



  /**
   * Updates assessment data to handle signature deletion
   * Complete centralized fix that prevents deleted signatures from reappearing
   */
  updateAssessmentDataOnDelete(): void {
    try {
      if (!this.versionItem?.controls?.assesments?.value || !this.assesmentNumber) return;

      const assessmentArray = this.versionItem.controls.assesments.value;
      const assessment = assessmentArray.find(el => el.assessmentID === this.assesmentNumber);

      if (assessment) {
        const assessmentIndex = assessmentArray.indexOf(assessment);
        const assessmentControl = this.versionItem.controls.assesments.at(assessmentIndex);

        if (this.isChildItem) {
          // For child items, clear all child-specific data sources

          // 1. Clear child form controls
          const childControl = this.versionItem?.controls?.childItems?.controls?.[this.group]
            ?.controls?.[this.groupItem]?.controls?.[this.child];

          if (childControl?.controls) {
            childControl.controls.childValue?.setValue(null);
            childControl.controls.imageValue?.setValue(null);
          }

          // 2. Clear child signature from childItemResponses JSON
          if (assessmentControl?.controls?.childItemResponses?.value) {
            try {
              const childItemResponses = JSON.parse(assessmentControl.controls.childItemResponses.value);
              const childItemIndex = childItemResponses.findIndex(
                item => item.ChildItemID == this.childData?.ChildItemID &&
                       item.GroupNumber == this.childData?.groupNo
              );

              if (childItemIndex > -1) {
                // Clear attachments and value for this specific child item
                childItemResponses[childItemIndex].Attachments = [];
                childItemResponses[childItemIndex].Value = null;

                // Update the assessment control with modified data
                assessmentControl.controls.childItemResponses.setValue(
                  JSON.stringify(childItemResponses)
                );
              }
            } catch (parseError) {
              console.error('Error clearing child item responses:', parseError);
            }
          }

          // Note: Do NOT clear assessment-level data for child items (preserve parent signatures)

        } else {
          // For parent items, clear assessment-level data sources

          // 1. Clear assessment files array
          assessmentControl?.controls?.files?.clear();

          // 2. Clear assessment imageValue and value
          assessmentControl?.controls?.imageValue?.setValue(null);
          assessmentControl?.controls?.value?.setValue(null);
        }
      }
    } catch (error) {
      console.error('Error updating assessment data:', error);
    }
  }

  /**
   * Enables editing mode for an existing signature/doodle
   * Hides action buttons and notifies parent of unsaved changes
   * @param category - Component category identifier
   * @param index - Component index identifier
   */
  editSignature(category, index) {
    try {
      this.signatureSaved.emit(false);
      this.showAdditionalActions = false;

      this.emitCustomCallback();
      this.notifyEditCallback(false);
      this.submit = false;
    } catch (error) {
      console.error('Error editing signature:', error);
      this.toastMessage('Error editing signature');
    }
  }

  /**
   * Saves the current signature/doodle drawing
   * Validates that something is drawn, converts to base64, and emits data to parent
   * Shows action buttons and marks as submitted
   */
  SaveSignature() {
    try {
      this.signatureSaved.emit(true);

      const data = this.signaturePad?.toData();
      if ((this.signaturePad?.isEmpty() || (data && data.length <= 0)) && !this.duplicateImage) {
        const message = this.type === this.signatureType
          ? 'Please put your signature'
          : 'Please update doodle';
        this.toastMessage(message);
        return;
      }

      const dataURL = this.signaturePad.toDataURL();
      if (!dataURL) {
        this.toastMessage('Error capturing signature');
        return;
      }

      const base64Img = dataURL.replace("data:image/png;base64,", "");
      this.duplicateImage = dataURL;

      const arrayToPass = this.createDataObject(base64Img, dataURL);
      this.CustomCallBack.emit(arrayToPass);

      this.showAdditionalActions = true;
      this.submit = true;
    } catch (error) {
      console.error('Error saving signature:', error);
      this.toastMessage('Error saving signature');
    }
  }

  /**
   * Creates a data object with signature/doodle information for parent component
   * Includes base64 image, component identifiers, and child item data if applicable
   * @param base64Img - Base64 encoded image string
   * @param dataURL - Complete data URL with base64 prefix
   * @returns Object containing all relevant signature/doodle data
   */
  createDataObject(base64Img: string, dataURL: string): any {
    const baseObj = {
      image: base64Img,
      index: this.index,
      category: this.category,
      original: dataURL,
      isChildItem: this.isChildItem
    };

    if (this.isChildItem) {
      return {
        ...baseObj,
        group: this.group,
        groupItem: this.groupItem,
        child: this.child,
        childData: this.childData
      };
    }

    return baseObj;
  }

  /**
   * Emits a custom callback with empty data to notify parent of changes
   * Used when clearing or deleting signatures to update parent state
   */
  emitCustomCallback(): void {
    const arrayToPass = this.createDataObject("", "");
    this.CustomCallBack.emit(arrayToPass);
  }

  /**
   * Displays error messages using toast notifications
   * Handles translation and fallback to original message if translation fails
   * @param message - Message key or text to display
   */
  toastMessage(message) {
    try {
      let toastText = '';
      this.translatorService.get(message).subscribe(translatesText => {
        toastText = translatesText || message;
        this.toastr.error(toastText, '', {
          positionClass: 'toast-bottom-right',
        });
      });
    } catch (error) {
      console.error('Error displaying toast message:', error);
      this.toastr.error(message, '', {
        positionClass: 'toast-bottom-right',
      });
    }
  }

  /**
   * Component initialization lifecycle hook
   * Sets up branding subscriptions, CSS variables, and initial UI state
   * Checks skip status for non-child items
   */
  ngOnInit(): void {
    try {
      this.brandingSubscription$ = this.interactorService.brandingDetailsCast.subscribe(data => {
        if (data) {
          this.brandingDetails = data;
          this.updateCssVariables();
        }
        this.setBackgroundColors();
      });

      this.updateCssVariables();

      if (!this.isChildItem) {
        this.checkInitialSkipStatus();
      }

      this.updateUIBasedOnStatus();
    } catch (error) {
      console.error('Error in ngOnInit:', error);
    }
  }

  /**
   * Updates CSS custom properties with branding colors
   * Sets theme colors for various UI elements from branding configuration
   */
  updateCssVariables(): void {
    if (!this.brandingDetails?.branding?.BackgroundColors) return;

    const colors = this.brandingDetails.branding.BackgroundColors;
    document.documentElement.style.setProperty('--greenColor', colors.YesTick);
    document.documentElement.style.setProperty('--blackColor', colors.TableFontColor);
    document.documentElement.style.setProperty('--redColor', colors.RequiredAsterisk);
    document.documentElement.style.setProperty('--whiteColor', colors.RowHoverNotification);
    document.documentElement.style.setProperty('--btnDelete', colors.ConfirmDeleteBtnHover);
    document.documentElement.style.setProperty('--currentCard', colors.CurrentCardBackground);
  }

  /**
   * Checks if the current assessment is skipped during component initialization
   * Clears signature pad if assessment is marked as skipped
   */
  checkInitialSkipStatus(): void {
    const assessmentArray = this.versionItem?.controls?.assesments?.value;
    if (!assessmentArray) return;

    assessmentArray.forEach(element => {
      if (element.assessmentID === this.assesmentNumber) {
        this.isSkipped = element?.isSkipped;
      }
    });

    if (this.isSkipped) {
      this.clearSignature();
    }
  }

  /**
   * Updates UI elements based on questionnaire and assessment status
   * Disables interactions for submitted questionnaires or skipped assessments
   */
  updateUIBasedOnStatus(): void {
    if (this.qStatus === 'Submitted' || this.isSkipped) {
      this.showAdditionalActions = false;
      this.showIcons = false;
      this.submit = true;
    } else {
      this.showIcons = true;
      if (!this.signatureSubmitted && !this.duplicateImage) {
        this.showAdditionalActions = false;
        this.submit = false;
      }
    }
  }

  /**
   * Sets component background colors from branding configuration
   * Updates local color properties used in the component template
   */
  setBackgroundColors() {
    if (!this.brandingDetails?.branding?.BackgroundColors) return;

    this.redColor = this.brandingDetails.branding.BackgroundColors.RequiredAsterisk;
    this.whiteColor = this.brandingDetails.branding.BackgroundColors.RowHoverNotification;
    this.currentCard = this.brandingDetails.branding.BackgroundColors.CurrentCardBackground;
  }

  /**
   * Component cleanup lifecycle hook
   * Unsubscribes from observables and prevents memory leaks
   */
  ngOnDestroy(): void {
    // Clean up branding subscription
    if (this.brandingSubscription$) {
      this.brandingSubscription$.unsubscribe();
    }

    // Remove event listeners from signature pad if it exists
    if (this.signaturePad) {
      try {
        // Remove any event listeners that might be attached
        this.signaturePad._canvas?.removeEventListener('mousedown', this.signaturePad._handleMouseDown);
        this.signaturePad._canvas?.removeEventListener('mousemove', this.signaturePad._handleMouseMove);
        this.signaturePad._canvas?.removeEventListener('mouseup', this.signaturePad._handleMouseUp);
        this.signaturePad._canvas?.removeEventListener('touchstart', this.signaturePad._handleTouchStart);
        this.signaturePad._canvas?.removeEventListener('touchmove', this.signaturePad._handleTouchMove);
        this.signaturePad._canvas?.removeEventListener('touchend', this.signaturePad._handleTouchEnd);
      } catch (error) {
        console.error('Error cleaning up signature pad:', error);
      }
    }
  }
}
